import packageInfo from '../../package.json';

export const environment = {
  appVersion: packageInfo.version,
  production: true,
  API_URL: 'https://api.infistel.pe/api/',
  API_VERSION: 'v1',
};
